import httpUtils from '@/api'

const state = {
  cityList: [],
  subscribeList: [],
  travelInfo: {
    startInfo: {
      dangerLevel: 0,
    },
    endInfo: {
      dangerLevel: 0,
      subInfo: [],
    },
    foot: {
      time: '2020-08-10 14:00:00'
    },
    subscribeStatus: 0,
    templateStatus: 0,
    tools: [],
  }
}

const mutations = {
  SET_CITY_LIST(state, cityList = []) {
    state.cityList = cityList
  },
  SET_SUBSCRIBE_LIST(state, subscribeList = []) {
    state.subscribeList = subscribeList
  },
  SET_TRAVEL_INFO(state, travelInfo = {}) {
    Object.assign(
      state.travelInfo,
      travelInfo,
    )
  },
}

const actions = {
  async getCityList({ commit }, params) {
    const result = await httpUtils('getCityList', params, 'PneumoniaTravel')
    const { code, cityList } = result
    if (code !== 0) {
      throw result
    }
    commit('SET_CITY_LIST', cityList)
  },
  async checkTravel({ commit }, params) {
    const result = await httpUtils('checkTravel', params, 'PneumoniaTravel')
    console.log(result)
    const { code, startInfo, endInfo, foot, subscribeStatus, templateStatus, tools } = result
    if (code !== 0) {
      throw result
    }
    commit('SET_TRAVEL_INFO', {
      startInfo, endInfo, foot, subscribeStatus, templateStatus, tools
    })
  },
  async subscribe({ commit }, params) {
    const result = await httpUtils('subscribe', params, 'PneumoniaTravel')
    console.log(result)
    const { code } = result
    if (code !== 0) {
      throw result
    }
    commit('SET_TRAVEL_INFO', {
      subscribeStatus: 1
    })
    return true
  },
  async unSubscribe({ commit }, params) {
    const result = await httpUtils('unsubscribe', params, 'PneumoniaTravel')
    console.log(result)
    const { code } = result
    if (code !== 0) {
      throw result
    }
    commit('SET_TRAVEL_INFO', {
      subscribeStatus: 0
    })
    return true
  },
  async getSubscribeList({ commit }, params) {
    const result = await httpUtils('getSubscribeList', params, 'PneumoniaTravel')
    console.log(result)
    const { code, subscribeList } = result
    if (code !== 0) {
      throw result
    }
    commit('SET_SUBSCRIBE_LIST', subscribeList)
  },
  async checkCity({ commit }, params) {
    const result = await httpUtils('checkCity', params, 'PneumoniaTravel')
    console.log(result)
    const { code, subscribeList } = result
    if (code !== 0) {
      throw result
    }
    return result
  },
}

export default {
  namespaced: true,
  state,
  // getters,
  actions,
  mutations,
};
